import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadEditorDependencies } from 'ProtectedRoute/useLoadEditorDependencies';
import { PlaylistEditor } from 'PlaylistEditor';

export function EditPlaylistComponent() {
    // Kept for now. Nothing left on this page renders an editor directive, but the route is reached
    // from the Angular editor index and the bundle has not been audited for what else it provides.
    useLoadEditorDependencies();
    const [key, params] = useAngularToReactRoute<{ playlistId: string }>();

    // The route pattern requires the id, so it is always there by the time this renders.
    return <PlaylistEditor key={key} playlistId={params.playlistId!} />;
}
